

/**
 * Monitor dismissble alerts and track which one have been shown.  Requires the alerts to have a unique data-id
 * @param focusOnDismiss the element to focus on when alert is dismissed
 */
export const monitorDismissibleAlerts = (focusOnDismissSelector = ".navbar-brand") => {

    // get all the dismissable alerts
    const alerts = document.querySelectorAll(".alert.alert-dismissible");

    // get already dismissed alerts out of storage
    const closedIds = JSON.parse(sessionStorage.getItem('art-dismissed-alerts')) || [];

    try {
        // find which ones we can show and attach behaviour
        alerts.forEach((alert) => {

            // show alerts which haven't been dismissed
            if (alert.dataset.id && false === closedIds.includes(alert.dataset.id)) {

                // make it block level before show so that we get the transition
                alert.classList.add('d-block'); 

                // show the alert                
                alert.classList.add('show');                

                // add a listener to the BS close event and add remember which ones have been dismissed
                alert.addEventListener('closed.bs.alert', event => {

                    let newClosedIds = JSON.parse(sessionStorage.getItem('art-dismissed-alerts')) || [];
                    newClosedIds.push(event.currentTarget.dataset.id);

                    sessionStorage.setItem('art-dismissed-alerts', JSON.stringify(newClosedIds));

                    // according to docs the alert is removed from DOM; set focus to the next sibling of the current alert
                    // by default the logo is the next keyboard accessible item in our tree
                    document.querySelector(focusOnDismissSelector).focus();                               
                });
            }
        });
    }
    catch (e) {
        console.warn('There was an issue with dismissible alerts');
    }
}

